export default __webpack_public_path__ + "static/media/logo.8053fb29.svg";